import { cva, type VariantProps } from "class-variance-authority";
import React from "react";
import { cn } from "@/lib/utils";

const loaderVariants = cva(
	"rounded-full border-4 border-muted border-t-primary",
	{
		variants: {
			active: {
				true: "animate-spin",
				false: "",
			},
			size: {
				default: "h-10 w-10",
				sm: "h-8 w-8",
				lg: "h-12 w-12",
			},
		},
		defaultVariants: {
			active: true,
			size: "default",
		},
	}
);
interface LoaderProps
	extends React.HTMLAttributes<HTMLDivElement>,
		VariantProps<typeof loaderVariants> {
	description?: string;
}
export const Loading = React.forwardRef<HTMLDivElement, LoaderProps>(
	({ size, active, className, ...rest }, ref) => {
		return (
			<div
				aria-atomic="true"
				aria-live={active ? "assertive" : "off"}
				className={cn(loaderVariants({ active, size, className }))}
				ref={ref}
				title={"Cargando..."}
				{...rest}
			/>
		);
	}
);
Loading.displayName = "Loading";
